import React from 'react';
import './Header.css';

const Header = () => {
  return (
  <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top pe-2">
    <div className="container-fluid">
      <a className="navbar-brand" href="/"><span className='text-warning'>Utils</span>soft</a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
            <a className="nav-link" aria-current="page" href="/">Home</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" aria-current="page" href="/about">About</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/#">Services</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/#">Portfolio</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/#">Team</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/#">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
)};

export default Header;
